export const generateCertificateNumber = () => {
  const today = new Date();
  const yyyy = String(today.getFullYear());
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const dateStr = `${yyyy}${mm}${dd}`;
  const randomNum = String(Math.floor(Math.random() * 10000)).padStart(4, "0");

  return `${dateStr}${randomNum}`;
};

// VideoPlayer의 자동 생성과 마이페이지 백필이 같은 탭에서 겹쳐 호출되더라도
// 동일 user+course 요청은 하나의 in-flight promise를 공유해 check-then-create
// 경합으로 인한 수료증 중복 생성을 막는다.
const inFlightRequests = new Map();

// 완료된 강의에 대한 수료증이 없으면 새로 생성한다. 이미 있으면 아무 것도 하지 않고 null을 반환.
export const ensureCertificateIssued = ({
  userId,
  courseId,
  userName,
  checkCertificate,
  createCertificate,
}) => {
  const key = `${userId}-${courseId}`;
  if (inFlightRequests.has(key)) {
    return inFlightRequests.get(key);
  }

  const request = (async () => {
    let certificateExists = false;
    let certificateInfo = null;

    try {
      const checkResult = await checkCertificate(userId, courseId);
      certificateExists = checkResult.exists;
      certificateInfo = checkResult.certificateInfo;
    } catch (checkError) {
      if (checkError?.response?.status !== 404) {
        throw checkError;
      }
    }

    if (certificateExists || certificateInfo) {
      return null;
    }

    const certificateData = {
      certificate_id: generateCertificateNumber(),
      user_name: userName,
      completion_date: new Date().toISOString(),
      is_issued: false,
    };

    return createCertificate(userId, courseId, certificateData);
  })();

  inFlightRequests.set(key, request);
  request.finally(() => inFlightRequests.delete(key));

  return request;
};
